export const IMAGE_UPLOAD_URL =
  import.meta.env.VITE_API_BASE_URL + '/api/v1/notifications/upload-image/'
